import React, {lazy, Suspense} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Typography} from 'antd'

//style
import './index.css'
import typo from "../../constants/dictionaries";

const {Title} = Typography;

// Components
const QuyetDinhXuPhat = lazy(() => import('./QuyetDinhXuPhatViPham'))
const TramQuanTrac = lazy(() => import('./TramQuanTrac'))

const TKTTramQT = lazy(() =>import('./TKT-TramQuanTrac'))

const KHTKTList = lazy(() => import('./KeHoachThanhKiemTra/List'));
const KHTKTForm = lazy(() => import('./KeHoachThanhKiemTra/Form'));

export default ({match}) => {
  const QuyetDinhXuPhatViPham = 'quyet-dinh-xu-phat-vi-pham'
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/${QuyetDinhXuPhatViPham}`} component={QuyetDinhXuPhat}/>
        <Route exact path={`${match.path}/tram-quan-trac`} component={TramQuanTrac}/>
        <Route exact path={`${match.path}/tram-quan-trac-thanh-kiem-tra`} component={TKTTramQT}/>

        <Route exact path={`${match.path}/ke-hoach-thanh-kiem-tra`} render={(props) => <KHTKTList {...props} />}/>
        <Route path={`${match.path}/ke-hoach-thanh-kiem-tra/add`} render={(props) => <KHTKTForm {...props} />}/>
        <Route path={`${match.path}/ke-hoach-thanh-kiem-tra/:id/edit`} render={(props) => <KHTKTForm {...props} />}/>

      </Switch>
    </Suspense>
  )
}